<script setup lang="ts">
import Page from '@/shared/components/layouts/Page.vue';
import CriticalitySetupWorkspace from '../../components/criticality/setup/CriticalitySetupWorkspace.vue';

definePage({ meta: { title: 'Criticality Setup' } });
</script>

<template>
  <Page>
    <CriticalitySetupWorkspace />
  </Page>
</template>
